import { render } from "./RedDivider.vue?vue&type=template&id=0d71f46c&scoped=true"
import script from "./RedDivider.vue?vue&type=script&lang=js"
export * from "./RedDivider.vue?vue&type=script&lang=js"

import "./RedDivider.vue?vue&type=style&index=0&id=0d71f46c&lang=scss&scoped=true"

import exportComponent from "E:\\_www\\gxwhcy\\view\\index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d71f46c"]])

export default __exports__